module.exports = __webpack_public_path__ + "img/thumb-loja.5175b497.jpeg";